import * as Constants from '@/common/utils/constants';

export default {
  ordinary: {
    'main': '#2d93fa',
    'main1': '#74c3fc',
    'main2': '#d9ecfe',
    'main3': '#5babfb',
    'main4': '#e9f6fe',
    'main5': '#f25555',
    'main6': '#b5d4ff',
    'main7': '#73aefe',
    'main8': '#e9f6fe',
    'main9': '#e4e8f1',
    'main10': '#d1dbe5',
    'main11': '#4db3fa',
    'main12': 'linear-gradient(180deg, #5babfb 0%, #ffffff 120%)'
  },
  // 泰安市妇幼保健院
  [Constants.HOSPITAL_ID_TAFY]: {
    'main': '#d83674',
    'main1': '#f2498a',
    'main2': '#fa96bc',
    'main3': '#f2498a',
    'main4': '#fcdee9',
    'main5': '#eba417',
    'main6': '#e99bb9',
    'main7': '#ffffff',
    'main8': '#fedeea',
    'main9': '#fedeea',
    'main10': '#f8bed3',
    'main11': 'rgba(207, 44, 107, 0.8)', // #cf2c6b
    'main12': 'linear-gradient(180deg, #fa96bc 0%, #ffffff 120%)'
  },
  // 山东省立医院
  [Constants.HOSPITAL_ID_SDSL]: {
    'main': '#81662e',
    'main1': '#97742b',
    'main2': '#f7dba0',
    'main3': '#c98700',
    'main4': '#fffdf4',
    'main5': '#f8000e',
    'main6': '#fad796',
    'main7': '#e0ad4c',
    'main11': 'rgba(129, 102, 46, 0.8)', // #81662e
    'main12': 'linear-gradient(180deg, #f7dba0 0%, #ffffff 120%)'
  },
  // 青岛市市立医院
  [Constants.HOSPITAL_ID_QDSL]: {
    'main': '#00653e',
    'main1': '#388165',
    'main2': '#529e77',
    'main3': '#20c586',
    'main4': '#f2fffa',
    'main5': '#f6b23b',
    'main6': '#77c9ab',
    'main7': '#ffffff',
    'main11': '#00653e',
    'main12': 'linear-gradient(180deg, #09b26f 0%, #f2fffa 120%)'
  },
  // 济南市妇幼保健院
  [Constants.HOSPITAL_ID_JNFY]: {
    'main': '#d83674',
    'main1': '#f2498a',
    'main2': '#fa96bc',
    'main3': '#f2498a',
    'main4': '#fcdee9',
    'main5': '#eba417',
    'main6': '#e99bb9',
    'main7': '#ffffff',
    'main8': '#fedeea',
    'main9': '#fedeea',
    'main10': '#f8bed3',
    'main11': 'rgba(207, 44, 107, 0.8)', // #cf2c6b
    'main12': 'linear-gradient(180deg, #fa96bc 0%, #ffffff 120%)'
  },
  // 聊城市脑科医院
  [Constants.HOSPITAL_ID_LCNK]: {
    'main': '#019a42',
    'main1': '#77dd88',
    'main2': '#d2f8d8',
    'main3': '#60c36f',
    'main4': '#bbf0c4',
    'main5': '#fd6d43',
    'main6': '#bbf0c5',
    'main7': '#6cd67d',
    'main11': '#8cdebd', // #8cdebd
    'main12': 'linear-gradient(180deg, #09b26f 0%, #f2fffa 120%)'
  },
  // 山东省第二人民医院
  [Constants.HOSPITAL_ID_SLX]: {
    'main': '#c4a356',
    'main1': '#c48756',
    'main2': '#edcc80',
    'main3': '#97742b',
    'main4': '#faeac5',
    'main5': '#7ac456',
    'main6': '#c4c1bc',
    'main7': '#6cd67d',
    'main11': 'rgba(179, 150, 82, 0.8)', // #b39652
    'main12': 'linear-gradient(180deg, #b39652 0%, #ffffff 120%)'
  },
  // 聊城市人民医院
  [Constants.HOSPITAL_ID_LCRM]: {
    'main': '#019a42',
    'main1': '#77dd88',
    'main2': '#d2f8d8',
    'main3': '#60c36f',
    'main4': '#bbf0c4',
    'main5': '#fd6d43',
    'main6': '#bbf0c5',
    'main7': '#6cd67d',
    'main11': '#8cdebd', // #8cdebd
    'main12': 'linear-gradient(180deg, #09b26f 0%, #f2fffa 120%)'
  },
  // 山东大学齐鲁医院
  [Constants.HOSPITAL_ID_SDQL]: {
    'main': '#008080',
    'main1': '#008b8b',
    'main2': '#48d1cc',
    'main3': '#008080',
    'main4': '#effbf9',
    'main5': '#3cb371',
    'main6': '#40e0d0',
    'main7': '#6cd67d',
    'main11': 'rgba(80, 199, 99, 0.8)', // #50c763
    'main12': 'linear-gradient(180deg, #f2fffa 0%, #09b26f 120%)'
  },
  // 菏泽市立医院
  [Constants.HOSPITAL_ID_HZSL]: {
    'main': '#81662e',
    'main1': '#97742b',
    'main2': '#f7dba0',
    'main3': '#c98700',
    'main4': '#fffdf4',
    'main5': '#f8000e',
    'main6': '#fad796',
    'main7': '#e0ad4c',
    'main11': 'rgba(129, 102, 46, 0.8)', // #81662e
    'main12': 'linear-gradient(180deg, #f7dba0 0%, #ffffff 120%)'
  },
  // 济宁市兖州区人民医院
  [Constants.HOSPITAL_ID_JNYZ]: {
    'main': '#3d55aa',
    'main1': '#4a68d4',
    'main2': '#b9d3eb',
    'main3': '#7a8ed6',
    'main4': '#e9f6fe',
    'main5': '#f25555',
    'main6': '#b5d4ff',
    'main7': '#73aefe',
    'main8': '#e9f6fe',
    'main9': '#e4e8f1',
    'main10': '#d1dbe5',
    'main11': '#3c8ec7',
    'main12': 'linear-gradient(180deg, #7a8ed6 0%, #ffffff 120%)'
  }
};
